import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataLakeBackends } from "@graylog/enterprise-api";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { DATA_LAKE_API_ROUTES, DATA_LAKE_CONFIG_QUERY_KEYS, DATA_LAKE_BACKEND_QUERY_KEYS } from "data-lake/Constants";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
const createDataLakeBackend = async (backend) => fetch("POST", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.backend.base().url), { ...backend });
const updateDataLakeBackend = async (backend) => fetch("PUT", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.backend.update(backend.id).url), { ...backend });
const deleteDataLakeBackend = async (id) => DataLakeBackends.remove(id);
const useCreateDataLakeBackend = (successHandler = void 0) => {
  const queryClient = useQueryClient();
  const {
    mutateAsync,
    isPending: isLoading,
    error
  } = useMutation({
    mutationFn: createDataLakeBackend,
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.backend_created", { ns: "enterprise_data_lake" }));
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_QUERY_KEYS });
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
      if (successHandler) {
        successHandler();
      }
    },
    onError: (err) => {
      UserNotification.error(
        i18n.t("notifications.backend_create_failed", { ns: "enterprise_data_lake", error: err.toString() }),
        i18n.t("notifications.backend_create_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return {
    mutateAsync,
    isLoading,
    error
  };
};
const useUpdateDataLakeBackend = (successHandler = void 0) => {
  const queryClient = useQueryClient();
  const {
    mutateAsync,
    isPending: isLoading,
    error
  } = useMutation({
    mutationFn: updateDataLakeBackend,
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.backend_updated", { ns: "enterprise_data_lake" }));
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_QUERY_KEYS });
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
      if (successHandler) {
        successHandler();
      }
    },
    onError: (err) => {
      UserNotification.error(
        i18n.t("notifications.backend_update_failed", { ns: "enterprise_data_lake", error: err.toString() }),
        i18n.t("notifications.backend_update_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return {
    mutateAsync,
    isLoading,
    error
  };
};
const useDeleteDataLakeBackend = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: deleteDataLakeBackend,
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.backend_deleted", { ns: "enterprise_data_lake" }));
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_QUERY_KEYS });
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
    },
    onError: (err) => {
      UserNotification.error(
        i18n.t("notifications.backend_delete_failed", { ns: "enterprise_data_lake", error: err.toString() }),
        i18n.t("notifications.backend_delete_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return {
    mutateAsync,
    isLoading
  };
};
export { useCreateDataLakeBackend, useUpdateDataLakeBackend, useDeleteDataLakeBackend };
